export enum NetworkErrors {
  NoInternet = 'Errors_NoInternet',
  Maintenance = 'Errors_Maintenance',
}
